import {DEFAULT_AI_ASSISTANT_SETTINGS} from './defaultAIAssistantSetting.js';
import {DEFAULT_INBOX_SETTINGS} from './defaultInboxSettings.js';
import {DEFAULT_SUGGESTION_FAQs} from './defaultSuggestionFAQs.js';
import {DEFAULT_DISPLAY_PAGES, DISPLAY_DEVICES} from './widgetDisplay.js';

export const WELCOME_POPUP_ADVANCED_TRIGGER_TYPE = {
  AFTER_TIME: 'after_time',
  AFTER_SCROLL: 'after_scroll'
};

export const WELCOME_POPUP_ADVANCED_DISPLAY_TYPE = {
  ALWAYS: 'always',
  CUSTOM: 'custom'
};

export const PRECHAT_CUSTOMER_CHAT_AS = {
  GUEST: 'guest',
  ANONYMOUS: 'anonymous',
  BOTH: 'both'
};

export const OPTION_ONLINE_STAFF = {
  DURING_BUSINESS_HOURS: 'during_hours',
  DURING_BUSINESS_HOURS_OR_WHEN_ANY_AGENT_IS_ONLINE: 'during_hours_or_online'
};

export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

/** @type { App.WidgetSetting } */
export const defaultWidgetSetting = {
  actionColor: '#303030',
  appCss: '',
  backBtnLabel: 'Back',
  breakTimes: [{startTimeBreak: '12:00', endTimeBreak: '13:00'}],
  isShowFirstReply: true,
  onlineMessage: "Thank you for reaching out. We'll be with you in a moment",
  offlineMessage: `Thanks for your message! We've received your contact details and will get back to you soon.`,
  brandColor: '#D1D5D6',
  floatBtnLabel: 'Chat with us',
  floatBtnLauncher: 'icon-only',
  floatBtnLabelColor: '#FFFFFF',
  floatBtnSize: '55px',
  floatBtnPosition: 'bottom_right',
  hideOnMobile: false,
  isCustom: true,
  textColor: '#303030',
  btnPopupColor: '#303030',
  gradientColorOne: '#D1D5D6',
  gradientColorSecond: '#F2F6F7',
  welcomeText: 'Hi 👋',
  description: 'How can we help you?',
  icon: 'chatty',
  customCss: '',
  isEnableChatFocus: true,
  isLiveChat: false,
  isContactUs: false,
  urlStoreAvatar: '',
  defaultContactMethod: 'whatsApp',
  contactMethod: {
    whatsApp: {active: false, value: '', title: 'WhatsApp'},
    messenger: {active: false, value: '', title: 'Messenger'},
    phoneCall: {active: false, value: '', title: 'Phone Call'},
    email: {active: false, value: '', title: 'Email'},
    instagram: {active: false, value: '', title: 'Instagram'},
    telegram: {active: false, value: '', title: 'Telegram'},
    /**
     * removed
     * @link https://www.notion.so/avadagroup/Chatbox-n-contact-method-We-chat-8114eaeed778449496c27ca82c7c4f94?pvs=4
     */
    // weChat: {
    //   active: false,
    //   value: '',
    //   title: 'WeChat',
    // },
    skype: {active: false, value: '', title: 'Skype'},
    line: {active: false, value: '', title: 'Line'},
    zalo: {active: false, value: '', title: 'Zalo'},
    sms: {active: false, value: '', title: 'SMS'},
    tiktok: {active: false, value: '', title: 'TikTok'}
  },
  welcomePopupSetting: {
    audience: ['all'],
    title: 'Hi there 👋',
    teaserMessage: 'Hi there 👋\nHow can we help?',
    onlineMessage: 'Hi {{customer_name}} 👋\nHow can we help you?',
    offlineMessage: `Hi {{customer_name}} 👋\nWe are currently offline. We will respond as soon as possible during our next business hours.`,
    useOfflineMessage: false,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    showOnDesktop: true,
    showOnMobile: true,
    titleTextFont: 'Inter',
    messageTextFont: 'Inter',
    displayTimeShowWelcome: 'all_time',
    statusTeaser: true,
    device: ['all'],
    advancedSettings: {
      trigger: {type: WELCOME_POPUP_ADVANCED_TRIGGER_TYPE.AFTER_TIME, value: 5},
      display: {
        type: WELCOME_POPUP_ADVANCED_DISPLAY_TYPE.CUSTOM,
        value: 8
      }
    }
  },
  newsletterPopupSettings: {
    title: `Don't miss out 👋`,
    teaserMessage: `Don't miss out 👋\nDiscover your special offer waiting just for you!`,
    invitationMessage: `Don't miss out 👋\nDiscover your special offer waiting just for you!`,
    welcomeMessage: 'Subscribe to get hot deals, exclusive updates and rewards.',
    successMessage: `Thank you for subscribing! Check your inbox and stay tuned for the latest news and exclusive offers.`,
    introduction: 'Subscribe now to get your offer!',
    formFields: ['email'],
    discount: null,
    statusTeaser: true,
    isEnableMarketingOptIn: false
  },
  productPopupSettings: {
    content: 'You might like this product!',
    productsList: [
      {
        id: 1,
        img:
          'https://teak-furniture-singapore.com/cdn/shop/products/BenjaminBookcase9_695x717.jpg?v=1668932554',
        name: 'Benjamin Bookcase',
        price: '$100.00',
        onlineStoreUrl: '#'
      }
    ],
    statusTeaser: true
  },
  cartBoosterPopupSettings: {
    title: 'Cart Booster',
    teaserMessage: 'Oops, you left something behind! Want to complete your order?',
    statusTeaser: true
  },
  aiAssistantSettings: DEFAULT_AI_ASSISTANT_SETTINGS,
  teamSize: '',
  channels: [],
  quickReplySettings: {
    suggestionFAQs: DEFAULT_SUGGESTION_FAQs
  },
  isEnableDisclaimerConsent: true,
  disclaimerConsent: `<p>By sending us a message, you agree to our <a href="https://{{shopifyDomain}}/policies/privacy-policy" rel="noopener noreferrer" target="_blank">privacy policy</a>.</p>`,
  privacyUrl: '',
  isOrderTracking: true,
  isFeaturedArticles: true,
  isCategory: false,
  isEnableQuickReplies: true,
  isRedirectUrl: 'custom',
  redirectUrl: 'https://t.17track.net/en#nums=',
  isEnableAIAssistant: false,
  theme: 'cloud',
  contentTextFont: 'Inter',
  headingTextFont: 'Inter',
  typeWorking: 'all_day',
  customTime: {
    monday: {label: 'Monday', isSelect: true, timeStart: '09:00', timeEnd: '17:00'},
    tuesday: {label: 'Tuesday', isSelect: true, timeStart: '09:00', timeEnd: '17:00'},
    wednesday: {label: 'Wednesday', isSelect: true, timeStart: '09:00', timeEnd: '17:00'},
    thursday: {label: 'Thursday', isSelect: true, timeStart: '09:00', timeEnd: '17:00'},
    friday: {label: 'Friday', isSelect: true, timeStart: '09:00', timeEnd: '17:00'},
    saturday: {label: 'Saturday', isSelect: false, timeStart: '09:00', timeEnd: '17:00'},
    sunday: {label: 'Sunday', isSelect: false, timeStart: '09:00', timeEnd: '17:00'}
  },
  onlineStatus: 'We are online',
  offlineStatus: 'Usually reply in a few minutes',
  isShowBreakTime: false,
  startTimeBreak: '12:00',
  endTimeBreak: '13:00',
  isShowHoliday: false,
  holidays: [],
  showNavigation: false,
  coverageRatio: '90',
  isEnableShortcut: true,
  colorMode: 'light_mode',
  isGradient: false,
  isEnableFollowUpEmail: false,
  displayDevices: DISPLAY_DEVICES.ALL,
  displayPages: DEFAULT_DISPLAY_PAGES,
  isShowNamePreChat: false,
  brandingRemoval: false,
  preChatFields: ['email'],
  inboxSettings: DEFAULT_INBOX_SETTINGS,
  logoHeader: null,
  onAutoResolve: true,
  timeAutoResolve: '60',
  typeAutoResolve: 'minute',
  resolvedAlert: `This chat was closed due to inactivity. Feel free to send a message to reopen it - we're here to help!`,
  preChatCustomerChatAs: PRECHAT_CUSTOMER_CHAT_AS.BOTH,
  optionOnline: OPTION_ONLINE_STAFF.DURING_BUSINESS_HOURS,
  dateFormat: DEFAULT_DATE_FORMAT,
  isShowMemberAvatar: false,
  preChatDescription:
    'Please enter your contact information so we can keep you updated with our replies',
  isEnableCustomPhone: false,
  isEnableCustomZalo: false,
  optionFormDelay: 'messages',
  afterFormDelay: 0,
  afterNumberMessages: 3,
  isBlocked: false // dev store isBlocked = true
};

/**
 * @returns {boolean}
 */
export const isOutsideStaffHours = optionOnline => {
  return optionOnline !== OPTION_ONLINE_STAFF.DURING_BUSINESS_HOURS_OR_WHEN_ANY_AGENT_IS_ONLINE;
};

export const DEFAULT_REDIRECT_URL = 'https://t.17track.net/en#nums=';
